import { Field } from '@/crm-types/models/field-models';
import { AbstractRepository } from '@/repositories/abstract-repository';

export class FieldsRepository extends AbstractRepository<Field> {
    readonly endpoint = 'types/fields';

}
